import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import { getAuth } from 'firebase/auth';
import { getCsrfToken } from '../../utils/dev';
import { toast } from '../../utils/toast';
/*
 * Description
 * -------
 *
 * Logs out from Firebase and session, and visits sign in page.
 *
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Values
 * -------
 *
 * signOutPath - (required) - API endpoint to sign out
 * signInPath  - (required) - path to sign in page which will be visited after successful logout
 *
 * Usage
 * -------
 *
 * <button
 *   data-controller="logout"
 *   data-logout-sign-out-path-value="https://example.com"
 *   data-logout-sign-in-path-value="https://example.com"
 *   data-action="click->logout#logout"
 * >
 *  Logout
 * </button>
 */
export class Logout extends Controller {
    static values = { signOutPath: String, signInPath: String };
    async logout() {
        document.dispatchEvent(new CustomEvent('wlaDidLogout'));
        try {
            await getAuth().signOut();
            const response = await fetch(this.signOutPathValue, {
                method: 'DELETE',
                headers: {
                    'X-CSRF-Token': getCsrfToken(),
                },
            });
            if (!response.ok) {
                throw response;
            }
            Turbo.visit(this.signInPathValue);
        }
        catch (error) {
            toast('Something went wrong. Please try again.');
        }
    }
}
